import { useMutation, useQuery } from '@tanstack/react-query'
// import { addRole, updateRole, updateRoleStatus, deleteRole, getRoleList, getSpinnerRoleList } from '../api/roles'
import { createUserList, updateRole, updateRoleStatus, deleteRole, getUserList, getSpinnerRoleList } from '../api/userList'

// Roles
export const useGetUserList = (queryParams = '') => {
    return useQuery({
        queryKey: ['user_list', queryParams],
        queryFn: () => getUserList(queryParams),
    });
};

export const useGetSpinnerRoleList = (queryParams = '') => {
    return useQuery({
        queryKey: ['spinner_roles', queryParams],
        queryFn: () => getSpinnerRoleList(queryParams)
    });
};

export const useCreateUserList = () => {
    return useMutation({
        mutationFn: createUserList
    })
};

export const useUpdateRole = () => {
    return useMutation({
        mutationFn: updateRole
    })
};

export const useUpdateRoleStatus = () => {
    return useMutation({
        mutationFn: updateRoleStatus
    })
};

export const useDeleteRole = () => {
    return useMutation({
        mutationFn: deleteRole
    })
};